// extracted by mini-css-extract-plugin
export default {"navbar_wrapper":"Navbar_navbar_wrapper__LQ6q+"};